export const CONTEXT_MENU_SECTION_TESTID =
	'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-section';
